/**
 * Formatting Utilities
 *
 * Hulpfuncties voor het formatteren van data voor weergave.
 * Alle functies gebruiken Nederlandse locale en zijn geoptimaliseerd
 * voor leesbaarheid door chauffeurs.
 */

// =============================================================================
// DATE & TIME FORMATTING
// =============================================================================

/**
 * Formatteert een datetime naar leesbare aankomsttijd.
 * - Vandaag: "14:30"
 * - Andere dag: "ma 14:30"
 *
 * @param dateTimeString - ISO datetime string of Salesforce datetime
 * @returns Geformatteerde tijd string, of null als input ongeldig is
 */
export function formatArrivalTime(dateTimeString: string | undefined | null): string | null {
  if (!dateTimeString) return null;

  try {
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return null;

    const today = new Date();
    const isToday = date.toDateString() === today.toDateString();

    const timeStr = date.toLocaleTimeString('nl-NL', {
      hour: '2-digit',
      minute: '2-digit',
    });

    if (isToday) {
      return timeStr;
    }

    // Andere dag: voeg korte dagnaam toe
    const dayStr = new Intl.DateTimeFormat('nl-NL', {
      weekday: 'short',
    }).format(date);

    return `${dayStr} ${timeStr}`;
  } catch {
    return null;
  }
}

/**
 * Formatteert stopduur in minuten naar leesbare string.
 * - Onder 60 min: "15 min"
 * - 60+ min: "1u 30m"
 *
 * @param minutes - Aantal minuten
 * @returns Geformatteerde duur string, of null als input ongeldig is
 */
export function formatStoppageTime(minutes: number | undefined | null): string | null {
  if (minutes === undefined || minutes === null || minutes < 0) return null;

  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return mins > 0 ? `${hours}u ${mins}m` : `${hours}u`;
}
